exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container[_v-26bd69a6]{width:100%;min-height:100%;background:#f6f8fa;position:relative;overflow-y:scroll}", "", {"version":3,"sources":["/../../../../../../vue-loader/lib/style-rewriter.js?id=_v-26bd69a6&file=app.vue&scoped=true!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/sass-loader/index.js!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/vux-loader/src/style-loader.js!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/vue-loader/lib/selector.js?type=style&index=0!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/src/component/static_page/app.vue.style"],"names":[],"mappings":"AAAA,wBAAW,WAAW,gBAAgB,mBAAmB,kBAAkB,iBAAiB,CAAC","file":"app.vue","sourcesContent":[".container{width:100%;min-height:100%;background:#F6F8FA;position:relative;overflow-y:scroll}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=_v-26bd69a6&file=app.vue&scoped=true!./~/sass-loader!./~/vux-loader/src/style-loader.js!./~/vue-loader/lib/selector.js?type=style&index=0!./src/component/static_page/app.vue
// module id = 363
// module chunks = 13